import { createEffect } from "effector";
import {
  addVehicle,
  deleteVehicle,
  editVehicle,
  getVehicles,
  getVehiclesByClient,
  getVehiclesByFleet,
} from "../../services/vehicleService";
import { EditVehicle, NewVehicle, Vehicle } from "../../types/vehicles.types";
import { AppError } from "../../services/classes";

export const getVehiclesEffect = createEffect(async () => {
  return await getVehicles();
});

export const getVehiclesByClientEffect = createEffect<string, Vehicle[], AppError>(async (clientId: string) => {
  return await getVehiclesByClient(clientId);
});

export const getVehiclesByFleetEffect = createEffect<string, Vehicle[], AppError>(async (fleetId: string) => {
  return await getVehiclesByFleet(fleetId);
});

export const addVehicleEffect = createEffect<NewVehicle, Vehicle, AppError>(async (vehicle: NewVehicle) => {
  return await addVehicle(vehicle);
});

export const editVehicleEffect = createEffect<EditVehicle, Vehicle, AppError>(async (vehicle: EditVehicle) => {
  return await editVehicle(vehicle);
});

export const deleteVehicleEffect = createEffect<
  { id: string; isFleet: boolean },
  string,
  AppError
>(async ({ id, isFleet }) => {
  await deleteVehicle(id, isFleet);
  return id;
});
